// Generated from HtmlHelperExtensions.GetRandomColorPalette and CollectionExtensions.Shuffle.
// Preserve the seeded .NET palette so the same sorted groups keep their legacy colors.
export const leaderboardPalettes: Record<number, string[]> = {
	38: [
		"#202000",
		"#C00000",
		"#606060",
		"#008000",
		"#400040",
		"#002020",
		"#606000",
		"#000080",
		"#00C0C0",
		"#400000",
		"#0000E0",
		"#808000",
		"#808080",
		"#E08000",
		"#004040",
		"#00E0E0",
		"#0000C0",
		"#E0E0E0",
		"#600060",
		"#002000",
		"#006000",
		"#0000A0",
		"#C0C0C0",
		"#000020",
		"#C0C000",
		"#A00000",
		"#A0A000",
		"#800080",
		"#00E000",
		"#800000",
		"#A0A0A0",
		"#404000",
		"#00A000",
		"#200020",
		"#404040",
		"#00C000",
		"#E00000",
		"#008080",
		"#A000A0",
		"#C000C0",
		"#202020",
		"#200000",
		"#00A0A0",
		"#006060",
		"#000040",
		"#000060",
		"#004000",
		"#E000E0",
		"#600000",
	],
	117: [
		"#202020",
		"#600000",
		"#A0A000",
		"#A000A0",
		"#00C000",
		"#0000C0",
		"#800000",
		"#C0C0C0",
		"#00A000",
		"#200000",
		"#606000",
		"#600060",
		"#002000",
		"#C000C0",
		"#606060",
		"#E00000",
		"#E0E0E0",
		"#E08000",
		"#00E0E0",
		"#808080",
		"#E000E0",
		"#006060",
		"#00E000",
		"#006000",
		"#800080",
		"#000020",
		"#404040",
		"#004000",
		"#C0C000",
		"#00A0A0",
		"#002020",
		"#404000",
		"#0000E0",
		"#808000",
		"#0000A0",
		"#00C0C0",
		"#000080",
		"#000060",
		"#004040",
		"#000040",
		"#400040",
		"#008080",
		"#400000",
		"#A00000",
		"#008000",
		"#202000",
		"#200020",
		"#C00000",
		"#A0A0A0",
	],
	22: [
		"#002000",
		"#606000",
		"#200020",
		"#800000",
		"#000020",
		"#006000",
		"#0000C0",
		"#00A000",
		"#00C0C0",
		"#E08000",
		"#008000",
		"#400000",
		"#A00000",
		"#E0E0E0",
		"#404000",
		"#000060",
		"#000080",
		"#800080",
		"#008080",
		"#A000A0",
		"#00E000",
		"#C00000",
		"#006060",
		"#000040",
		"#00A0A0",
		"#400040",
		"#A0A000",
		"#0000E0",
		"#200000",
		"#0000A0",
		"#00C000",
		"#A0A0A0",
		"#808000",
		"#002020",
		"#00E0E0",
		"#E00000",
		"#202020",
		"#202000",
		"#004040",
		"#004000",
		"#600000",
		"#404040",
		"#600060",
		"#606060",
		"#E000E0",
		"#C000C0",
		"#808080",
		"#C0C0C0",
		"#C0C000",
	],
	96: [
		"#E00000",
		"#404000",
		"#400040",
		"#002000",
		"#A0A0A0",
		"#600000",
		"#A0A000",
		"#200000",
		"#404040",
		"#800080",
		"#000060",
		"#0000C0",
		"#E0E0E0",
		"#00C0C0",
		"#0000E0",
		"#00A000",
		"#0000A0",
		"#C0C0C0",
		"#202020",
		"#600060",
		"#008000",
		"#808000",
		"#C0C000",
		"#606060",
		"#E08000",
		"#006000",
		"#008080",
		"#C000C0",
		"#606000",
		"#E000E0",
		"#00C000",
		"#000040",
		"#C00000",
		"#006060",
		"#808080",
		"#400000",
		"#000020",
		"#004000",
		"#800000",
		"#002020",
		"#A00000",
		"#200020",
		"#A000A0",
		"#004040",
		"#202000",
		"#000080",
		"#00A0A0",
		"#00E0E0",
		"#00E000",
	],
};
